<script setup lang="ts">
import { AccordionContent, AccordionItem, AccordionTrigger } from '@/components/ui/accordion'
import { Permission } from '@/lib/permissions/v1'
import { useUserStore } from '@/stores/user'
import { UsageRouteName } from '@/views/usage/routes'

const user = useUserStore()
</script>

<template>
    <AccordionItem value="companies" class="border-b-0">
        <AccordionTrigger
            class="py-2 px-4 text-white hover:no-underline hover:bg-neutral-600/50 data-[state=open]:bg-zinc-800"
        >
            <div class="flex items-center">
                <div class="w-6">
                    <FontAwesomeIcon :icon="['fal', 'users']" class="size-4!" />
                </div>
                <div class="ml-3 text-xs">Companies</div>
            </div>
        </AccordionTrigger>
        <AccordionContent>
            <div class="flex flex-col text-white text-xs">
                <RouterLink to="/companies/all" class="pl-[52px] py-2 hover:bg-neutral-600/50"
                    >Companies</RouterLink
                >
                <RouterLink to="/companies/services" class="pl-[52px] py-2 hover:bg-neutral-600/50"
                    >Services</RouterLink
                >
                <RouterLink to="/companies/contacts" class="pl-[52px] py-2 hover:bg-neutral-600/50"
                    >Contacts</RouterLink
                >
                <RouterLink to="/companies/addresses" class="pl-[52px] py-2 hover:bg-neutral-600/50"
                    >Addresses</RouterLink
                >
                <RouterLink to="/companies/assets" class="pl-[52px] py-2 hover:bg-neutral-600/50"
                    >Assets</RouterLink
                >
                <RouterLink
                    v-if="user.hasPermission(Permission.CompanyServiceUsageViewAny)"
                    :to="{
                        name: UsageRouteName.Index,
                        query: {
                            'company-service-usage-sort': JSON.stringify([
                                {
                                    column: 'start_at',
                                    direction: 'desc',
                                },
                            ]),
                        },
                    }"
                    class="pl-[52px] py-2 hover:bg-neutral-600/50"
                >
                    Usage
                </RouterLink>
            </div>
        </AccordionContent>
    </AccordionItem>
</template>

<style scoped>
.router-link-active {
    background-color: rgba(255, 255, 255, 0.1);
}
</style>
